var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLikeSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.667969 14.0003H3.33464V6.00033H0.667969V14.0003ZM15.3346 6.66699C15.3346 5.93366 14.7346 5.33366 14.0013 5.33366H9.79464L10.428 2.28699L10.448 2.07366C10.448 1.80033 10.3346 1.54699 10.1546 1.36699L9.44797 0.666992L5.0613 5.06033C4.81464 5.30033 4.66797 5.63366 4.66797 6.00033V12.667C4.66797 13.4003 5.26797 14.0003 6.0013 14.0003H12.0013C12.5546 14.0003 13.028 13.667 13.228 13.187L15.2413 8.48699C15.3013 8.33366 15.3346 8.17366 15.3346 8.00033V6.66699Z",
    fill: "#DF6C20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeSelected);
export default __webpack_public_path__ + "static/media/likeSelected.da6e7da0a858c5cd68a2a9fcdce55483.svg";
export { ForwardRef as ReactComponent };